/**
 * Take the table away. One button, next to the table it downloads.
 */
import { useCallback } from 'react';

export default function DownloadCsv({
  csv,
  filename,
  label = 'Download CSV',
}: {
  /** Built lazily: shaping a large table on every render is wasted work. */
  csv: () => string;
  filename: string;
  label?: string;
}) {
  const save = useCallback(() => {
    // A BOM, so Excel reads UTF-8 rather than mangling every ® and é.
    const blob = new Blob(['﻿', csv()], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Freed on the next tick: revoking synchronously can beat the download.
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }, [csv, filename]);

  return (
    <button
      type="button"
      onClick={save}
      title={`Download this table as ${filename}`}
      data-testid="download-csv"
      className="px-2 py-0.5 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 text-xs"
    >
      ↓ {label}
    </button>
  );
}
